<template>
  <div style="padding:1px;">
    <hd></hd>
    <div class="contioner">
        <div class="businessTitle">
            <div>
                <div class="businessName">{{business.name}}</div>
            </div>
            <div>
                <div class="businessBar"></div>
            </div>
            <div>
                <a :href="url" target="_blank" class="businessWebsite">{{business.website}}</a>
            </div>
            <div style="margin-bottom:10px;">
                <div class="businessTxt">下单：{{business.support_order == '0'?'请咨询客服':business.support_order == '1'?"支持":'不支持'}}</div>
            </div>
            <div>
                <div class="businessTxt">下单+转运：{{business.support_buy == '0'?'请咨询客服':business.support_buy == '1'?"支持":'不支持'}}</div>
            </div>
            <div v-if="business.support_order == '1' && showbtn" style="margin-top:20px">
                <img src="@/assets/images/homepage/weapp.jpg" height="150" width="150"/>
            </div>
            <div v-if="business.support_order == '1'&&showbtn" style="text-align:left;" class="businessTaks">
                <task class="content task"></task>
            </div>
        </div>
        <div>
            <dd v-if="loading" class="text-center">
                <Loading></Loading>
            </dd>
            <ul v-if="!loading">
                <li v-for="item in goodList" @click="getGoodDetail(item)">
                    <div class="goodImg">
                        <img :src="item.picture_url">
                    </div>
                    <div>
                        <!-- <div class="addCart" >
                            <add-products :product="item" :business="business" v-on:success="success">
                                <img src="../../ico/addgood.png">
                                加入购物车
                            </add-products>
                        </div> -->
                        <div class="brandName">
                            {{item.brand_name}}
                        </div>
                    </div>
                    <div>
                        <div class="goodName">
                            {{item.name}}
                        </div>
                    </div>
                    <div>
                        <div class="goodprice" v-if="time > new Date(item.coupon_start).getTime() && time < new Date(item.coupon_end).getTime()">
                            <del>
                                {{item.currency_symbol}}{{item.price}}
                            </del>
                            <span>
                                {{item.currency_symbol}}{{item.discounted_price}}
                            </span>
                        </div>
                        <div v-else>
                            {{item.currency_symbol}}{{item.price}}
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <el-dialog v-if="completion" class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false" :visible.sync="completion" width="90%" @close="showForm = false">
            <div class="text-center redirct">
                <p><i class="ico ico-paysucces completion"></i></p>
                    <h1 style="padding: 60px 0 25px;">加入购物车成功</h1>
                </p>
            </div>
        </el-dialog>
    </div>
    <div class="yd-pagination" v-if="goodList && totalCount > form.limit" style="margin-bottom:20px;">
        <el-pagination
          :page-size="form.limit"
          :pager-count="5"
          :current-page.sync="form.page"
          layout="prev, pager, next"
          next-text="下一页"
          prev-text="上一页"
          :total="totalCount">
        </el-pagination>
      </div>
    <mobilefooter v-if="mobiletype"></mobilefooter>
    <ft v-else class="ft"></ft>
    <GlobalDialogs></GlobalDialogs>
  </div>
</template>

<script>
import hd from '../../components/Header'
import ft from '../../components/Footer'
import api from '../../services/api.js'
import task from '../home/Task'
import AddProducts from './AddProducts'
import { CURRENCIES } from '../../services/constant'
import mobilefooter from '../../components/mobilefooter'
import Loading from '../../components/Loading'
import GlobalDialogs from '../../components/GlobalDialogs'
let _ = require('lodash')
let $ = require('jQuery')

export default {
  name: 'Brands',
  components: {
    hd: hd,
    ft: ft,
    mobilefooter: mobilefooter,
    AddProducts: AddProducts,
    Loading: Loading,
    GlobalDialogs: GlobalDialogs,
    task: task
  },

  data () {
    return {
      showbtn: false,
      loading: true,
      mobiletype: false,
      screenWidth: document.body.clientWidth,
      CURRENCIES: CURRENCIES,
      business_id: '',
      business: {},
      url: null,
      goodList: '',
      time: '',
      website: '',
      completion: false,
      totalCount: null,
      form: {
        page: 1,
        limit: 30
      },
      tag: null
    }
  },
  created () {
    this.tag = this.$route.params.id
    if (document.body.clientWidth < 1024) {
      this.mobiletype = true
    }
    this.time = new Date().getTime()
    this.getBusinessID()
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    async getBusinessID () {
      let res = await api.getIDByTag(this, {
        tag: this.tag
      })
      if (res.body.status == 'ok') {
        this.business.id = res.body.result
        this.getBusiness()
        this.showbtn = true
        this.loading = false
        // this.getGoodList()
        // this.getGoodCount()
      }
    },
    async getBusiness () {
      let res = await api.getListByWebsite(this, {
        id: this.business.id
      })
      let business = res.body.result
      this.url = business[0].website
      this.business = {
        name: business[0].name,
        website: extractHostname(business[0].website),
        id: business[0].id,
        support_order: business[0].support_order,
        support_buy: business[0].support_buy
      }
    },
    async getGoodList () {
      this.loading = true
      let params = {
        business_id: this.business.id,
        page: this.form.page,
        limit: this.form.limit,
        tag: this.form.tag
      }
      let res = await api.getGoodList(this, params)
      if (res.body.status == 'ok') {
        this.loading = false
        this.goodList = res.body.result
        if (this.goodList.length && this.goodList.length > 0) {
          this.showbtn = false
          if (this.business.id == 45) {
            this.$router.push({name: 'Goods', params: {id: this.tag}})
          } else {
            this.$router.push({name: 'NormalProduct', params: {id: this.tag}})
          }
        } else {
          this.showbtn = true
        }
      }
    },

    async getGoodCount () {
      let params = {
        business_id: this.business.id
      }
      let res = await api.countGoodList(this, params)
      if (res.body.status == 'ok') {
        this.totalCount = Number(res.body.result)
      }
    },
    success () {
      this.completion = true
    },
    getGoodDetail (item) {
      this.$router.push({name: 'Item', params: {id: item.id}})
    }

  },

  watch: {
    screenWidth (val) {
      if (!this.timer) {
        this.screenWidth = val
        console.log(val)
        if (val < 1024) {
          this.mobiletype = true
        } else {
          this.mobiletype = false
        }
        this.timer = true
        let that = this
        setTimeout(function () {
          // that.screenWidth = tha t.$store.state.canvasWidth
          that.timer = false
        }, 400)
      }
    },
    form: {
      handler: function (val, oldVal) {
        this.getGoodList()
        this.getGoodCount()
      },
      deep: true
    },
    $route (to, from) {
      this.tag = this.$route.params.id
      this.getBusinessID()
    }
  }
}
function extractHostname (url) {
  url = String(url)
  var hostname
  var str = hostname
  if (url.indexOf('://') > -1) {
    hostname = url.split('/')[2]
    console.log(hostname)
  } else {
    hostname = url.split('/')[0]
  }

  console.log(str)

  // find & remove port number
  hostname = hostname.split(':')[0]
  // find & remove "?"
  hostname = hostname.split('?')[0]
  if (hostname == 'www.nike.com') {
    if (url.split('/')[3]) {
      str = url.split('/')[3]
      return hostname + '/' + str + '/'
    } else {
      return hostname
    }
  }
  return hostname
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .contioner {
        margin-top: 154px;
        .businessTitle{
            text-align: center;
            margin-bottom: 82px;

            .businessName {
                height:48px;
                font-size:34px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:48px;
                margin-bottom: 21px;
                display: inline-block;
            }
            .businessBar {
                width:70px;
                height:4px;
                background:rgba(51,51,51,1);
                display: inline-block;
                margin-bottom: 40px;
            }
            .businessWebsite {
                display: inline-block;
                height:22px;
                font-size:16px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:22px;
                margin-bottom: 20px;
            }
            .businessTxt {
                display: inline-block;
                width:194px;
                height:22px;
                font-size:16px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:22px;
            }
            a{
                color: #fff;
                font-size: 18px;
                .businessBtn{
                    text-align: center;
                    margin: 35px auto;
                    border-radius: 3px;
                    border: 1px solid white;
                    color: white;
                    background-color: #000;
                    width: 160px;
                    height: 46px;
                    font-size: 18px;
                    line-height: 46px;
                    cursor: pointer;

                }

            }

        }

        ul {
            padding-left: 170px;
            padding-right: 110px;
            overflow: hidden;
            li {
                margin-right: 40px;
                text-align: center;
                float: left;
                margin-bottom: 40px;
                overflow: hidden;
                width: 16%;
                cursor: pointer;
                height: 280px;

                .goodImg {
                    display:inline-block;
                    width:100%;
                    height:135px;
                    width: 135px;
                    margin-bottom: 21px;

                    img {
                        height: 135px;
                        width: 135px;
                        object-fit: contain;
                    }
                }
                .addCart {
                    display: inline-block;
                    width: 102px;
                    font-size:14px;
                    color: #666666;
                    margin-bottom: 20px;

                    img {
                        width: 22px;
                        height: 25px;
                        vertical-align: middle;
                        margin-right: 5px;
                    }
                }
                .goodName {
                    font-size:16px;
                    color: #333333;
                    margin-bottom: 10px;
                }
                .brandName {
                    font-weight: 600;
                    font-size: 16px;
                    color: #333;
                    margin-bottom: 10px;
                }
                .goodprice {
                    del {
                        color: #B0B4BF;
                        margin-right: 20px;
                    }
                    span {
                        color: #FF4650;
                    }
                }
            }
        }

        .redirct {
            font-size:24px;
            font-family:PingFangSC-Regular;
            line-height:33px;
            margin-top: 54px;
            padding-bottom: 70px;

            .completion {
                background-image: url('../../ico/blueSucccess@2x.png');
                background-position: 0 0;
                background-size: contain;
            }
        }
    }
@media screen and (max-width:1300px){
    .contioner {
        ul {

            li {
                width: 20%;
            }
        }
    }
}
@media screen and (max-width:1088px){
    .contioner {
        ul {

            li {
                width: 27%;
            }
        }
    }
}
@media screen and (max-width:1024px){
    .contioner {
        margin-top: 78px;
        margin-bottom: 30px;

        ul {
            padding-left: 10px;
            padding-right: 10px;

            li {
                width: 47%;
                margin-right: 10px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/merchant/merchant.vue